import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Spinner, Modal } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from "../../common/Avatar";
import { list, remove } from "../../../lib/api/club";
import { Add } from './Add';
import { Edit } from './Edit';
import { List as Staff } from '../clubstaff/Staff';
import { List as EditContact } from '../contact/Lista';
import { useAppContext } from 'providers/AppProvider';

import CardDropdown from 'components/common/CardDropdown';
import { Dropdown } from 'react-bootstrap';
import {_exportPDF} from "../../../lib/api/api";

export const List = () => {
    const [clubs, setClubs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const [showStaffModal, setShowStaffModal] = useState(false);
    const [selectedClub, setSelectedClub] = useState(null);

    const {userApp} = useAppContext();

    const handleNew = () => {
        setSelectedClub(null);
        setShowModal(true);
    };

    const handleEdit = (id) => {
        const club = clubs.find(c => c.document_guid === id);
        setSelectedClub(club);
        console.log('selectedClub',club)
        setShowModal(true);
    };

    const handleStaff = (id) => {
        const club = clubs.find(c => c.document_guid === id);
        setSelectedClub(club);
        console.log('selectedClub',club)
        setShowStaffModal(true);
    };

    const handleContact = (id) => {
        console.log("id ***",id)
        const club = clubs.find(c => c.document_guid === id);

        setSelectedClub(club);
        console.clear();
        console.log('club',club)
        console.log('SelectedClub',selectedClub)
        setShowContactModal(true);
    };

    const handelDelete = async (id) => {
        setIsLoading(true);
        try {
            await remove(id);
            setClubs(clubs.filter((item) => item.document_guid !== id));
        } catch (error) {
            console.error("Failed to delete item", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getClubs = () => {
        setIsLoading(true);
        list()
            .then((res) => setClubs(res))
            .catch((err) => console.error(err))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        getClubs();
    }, []);

    const playersToPdf = async (club_guid) => {
        return await _exportPDF(`report/pdf/${club_guid}`);
    };

    const stafToPdf = async (club_guid) => {
        return await _exportPDF(`report/pdf-staff/${club_guid}`);
    };

    const registrationToPdf = async (club_guid) => {
        return await _exportPDF(`report/pdf-registration/${club_guid}`);
    };

    const registrationTotalToPdf = async (club_guid) => {
        return await _exportPDF(`report/pdf-registration-total/${club_guid}`);
    };

    const renderActions = item => (
        <CardDropdown>
            <div className="py-2">
                <Dropdown.Item onClick={() => handleContact(item.document_guid)}>Kontakti</Dropdown.Item>
                <Dropdown.Item onClick={() => handleEdit(item.document_guid)}>Izmjeni</Dropdown.Item>
                <Dropdown.Divider/>
                <Dropdown.Item onClick={() => handleStaff(item.document_guid)}>Dodaj trenere i osoblje</Dropdown.Item>
                <Dropdown.Divider/>
                <Dropdown.Item onClick={() => playersToPdf(item.club_guid)}>Štampaj licence igrači</Dropdown.Item>
                <Dropdown.Item onClick={() => stafToPdf(item.club_guid)}>Štampaj licence treneri</Dropdown.Item>
                <Dropdown.Item onClick={() => registrationToPdf(item.club_guid)}>Štampaj preregistracija kluba i igrača</Dropdown.Item>
                {userApp?.role_type_id === "admin" && (
                    <>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => registrationTotalToPdf(item.club_guid)}>Štampaj potvrda</Dropdown.Item>
                    </>
                )}
                {/*<Dropdown.Item className='text-danger' onClick={() => handelDelete(item.document_guid)}>Delete</Dropdown.Item>*/}
            </div>
        </CardDropdown>
    );

    return (
        <Card className={classNames('h-100')}>
            <Card.Header>
                <Row className={classNames('g-2')}>
                    <Col>
                        <Flex>
                            <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                                Spisak klubova
                            </h5>
                        </Flex>
                    </Col>
                    <Col xs="auto">
                        <Button onClick={handleNew} variant="primary">
                            Dodaj klub
                        </Button>
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body className="bg-body-tertiary">
                {isLoading ? (
                    <div className="text-center">
                        <Spinner animation="border" role="status" />
                    </div>
                ) : (
                    <Row className="mb-3">
                        <div className="d-none d-xl-block">
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th scope="col">Klub</th>
                                    <th className="text-end" scope="col">Akcija</th>
                                </tr>
                                </thead>
                                <tbody>
                                {clubs.map((item, i) => (
                                    <tr key={i}>
                                        <td className="text-nowrap">
                                            <div className="d-flex align-items-center">
                                                <Avatar src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`} size="xl" name={item.name} />
                                                <div className="ms-2">{item.name}</div>
                                            </div>
                                        </td>
                                        <td className="text-end">{renderActions(item)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>

                        <div className="d-xl-none">
                            <Row className="g-3">
                                {clubs.map((item, i) => (
                                    <Col xs={12} key={i}>
                                        <div
                                            className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                                            style={{ borderColor: '#dfe3ee' }}
                                        >
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <div className="flex-shrink-0">
                                                    <Avatar
                                                        src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`}
                                                        size="2xl"
                                                        name={item.name}
                                                    />
                                                </div>
                                                <div className="flex-shrink-0">{renderActions(item)}</div>
                                            </div>

                                            <div className="mt-3">
                                                <div className="fw-semibold text-dark fs-8">{item.name}</div>
                                                {item.short_name && (
                                                    <div className="mt-2">
                                                        <span className="badge rounded-pill badge-subtle-primary">
                                                            {item.short_name}
                                                        </span>
                                                    </div>
                                                )}
                                                {item.place && (
                                                    <div className="text-600 fs-10 mt-2">{item.place}</div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Row>
                )}
            </Card.Body>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{selectedClub ? 'Izmijeni klub' : 'Dodaj klub'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedClub ? (
                        <Edit
                            initialData={selectedClub}
                            onClose={() => setShowModal(false)}
                            onSave={getClubs}
                        />
                    ) : (
                        <Add
                            onClose={() => setShowModal(false)}
                            onSave={getClubs}
                        />
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showContactModal} onHide={() => setShowContactModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{'Kontakt'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditContact
                        initPartner={selectedClub}
                        onClose={() => setShowContactModal(false)}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={showStaffModal} onHide={() => setShowStaffModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Dodaj trenere i ostalo osoblje</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Staff
                        initialData={selectedClub}
                        onClose={() => setShowStaffModal(false)}
                    />
                </Modal.Body>
            </Modal>
        </Card>
    );
};

export default List;
